import { render, staticRenderFns } from "./VrmModel.vue?vue&type=template&id=6f0686a5&scoped=true"
import script from "./VrmModel.vue?vue&type=script&lang=js"
export * from "./VrmModel.vue?vue&type=script&lang=js"
import style0 from "./VrmModel.vue?vue&type=style&index=0&id=6f0686a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0686a5",
  null
  
)

export default component.exports